import React, { memo } from 'react';
import CommentList from '../../../../../components/article/articlesRemark/CommentList';

interface IArticleCommentsProps {
  remarkData: { hotComment: any[], commentData: any[], commentNum: number, paging: string },
  type: string | undefined,
  id: string | number,
  refreshList: () => void,
}

const ArticleComments: React.FC<IArticleCommentsProps> = (props) => {

  const { remarkData, type, id, refreshList } = props;
  
  return (
    <>
      {remarkData.hotComment.length > 0 && (
        <div className="mt-40">
          <CommentList
            commentData={remarkData.hotComment}
            title="熱門評論"
            response={refreshList}
          />
        </div>
      )}

      {remarkData.commentData.length > 0 && (
        <div className="mt-40">
          <CommentList
            commentData={remarkData.commentData}
            response={refreshList}
          />
          {remarkData.commentNum > 10 && (
            <a
              className="w-full h-40 bg-[#224c96] flex items-center justify-center text-16 text-[#fff]"
              href={`/article/comments/list?type=${type}&id=${id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              查看全部 {remarkData.commentNum} 條評論 &gt;&gt;
            </a>
          )}
        </div>
      )}
    </>
  );
};

export default memo(ArticleComments);
